// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Work Sans', 'Work Sans Fallback'","fontStyle":"normal"},"className":"__className_a2025e","variable":"__variable_a2025e"};